export const mutations = {
    setLancamentoCaixa(state, data){
        state.lancamentoCaixa = data
    },
    setLancamentosCaixa(state, data){
        state.lancamentosCaixa = data
    },
    addLancamentoCaixa(state, data){
        state.lancamentosCaixa.data.unshift(data)
    },
    removeLancamentoCaixa(state, data){
        let index = state.lancamentosCaixa.data.map(x => x.id).indexOf(data.id);
        state.lancamentosCaixa.data.splice(index, 1)
    },
    setModalCadastroLancamentoCaixa(state, status){
        state.modalCadastroLancamentoCaixa = status
    },
    setModalListarLancamentoCaixa(state, status){
        state.modalListarLancamentoCaixa = status
    },
    setModalExcluirLancamentoCaixa(state, status){
        state.modalExcluirLancamentoCaixa = status
    },
    setModalRelatorioFechamentoCaixa(state, status){
        state.modalRelatorioFechamentoCaixa = status
    },
    setFormaPagamentoSelecionadaLancamentoCaixa(state, data) {
        state.formaPagamentoSelecionadaLancamentoCaixa = data
    }
}

export default {}